
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/scoped-css-baseline",
      function () {
        return require("private-next-pages/material-ui/api/scoped-css-baseline.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/scoped-css-baseline"])
      });
    }
  